(function() {
  var SUBSCRIPTION_SHIPPING_SAVINGS_CENTS = 495;
  var BOCC_5_SAVINGS_BREAKDOWN_VARIANT_ID = '01a0d244-26f4-7979-9005-eaf627b590d5';
  var BOCC_31_DESCRIPTION_FIRST_VARIANT_ID = '01a14155-41f9-7a7d-8af5-88d982f68e7d';
  var BOCC_65_SUBSCRIPTION_LABEL_VARIANT_ID = '01a1a236-ddcb-7927-890b-df28c16b4f58';
  var shopliftSavingsBreakdownPromise = null;
  var shopliftDescriptionFirstPromise = null;
  var shopliftSubscriptionLabelPromise = null;

  function isShopliftSavingsBreakdownVariant() {
    if (shopliftSavingsBreakdownPromise) {
      return shopliftSavingsBreakdownPromise;
    }

    shopliftSavingsBreakdownPromise = new Promise(function(resolve) {
      var startedAt = Date.now();

      function checkAssignment() {
        if (window.shoplift && typeof window.shoplift.isHypothesisActive === 'function') {
          window.shoplift.isHypothesisActive(BOCC_5_SAVINGS_BREAKDOWN_VARIANT_ID)
            .then(resolve)
            .catch(function(error) {
              console.warn('Shoplift BOCC-5 assignment failed:', error);
              resolve(false);
            });
          return;
        }

        if (Date.now() - startedAt >= 3000) {
          resolve(false);
          return;
        }

        window.setTimeout(checkAssignment, 50);
      }

      checkAssignment();
    });

    return shopliftSavingsBreakdownPromise;
  }

  function isShopliftDescriptionFirstVariant() {
    if (shopliftDescriptionFirstPromise) {
      return shopliftDescriptionFirstPromise;
    }

    shopliftDescriptionFirstPromise = new Promise(function(resolve) {
      var startedAt = Date.now();

      function checkAssignment() {
        if (window.shoplift && typeof window.shoplift.isHypothesisActive === 'function') {
          window.shoplift.isHypothesisActive(BOCC_31_DESCRIPTION_FIRST_VARIANT_ID)
            .then(resolve)
            .catch(function(error) {
              console.warn('Shoplift BOCC-31 assignment failed:', error);
              resolve(false);
            });
          return;
        }

        if (Date.now() - startedAt >= 3000) {
          resolve(false);
          return;
        }

        window.setTimeout(checkAssignment, 50);
      }

      checkAssignment();
    });

    return shopliftDescriptionFirstPromise;
  }

  function isShopliftSubscriptionLabelVariant() {
    if (shopliftSubscriptionLabelPromise) {
      return shopliftSubscriptionLabelPromise;
    }

    shopliftSubscriptionLabelPromise = new Promise(function(resolve) {
      var startedAt = Date.now();

      function checkAssignment() {
        if (window.shoplift && typeof window.shoplift.isHypothesisActive === 'function') {
          window.shoplift.isHypothesisActive(BOCC_65_SUBSCRIPTION_LABEL_VARIANT_ID)
            .then(resolve)
            .catch(function(error) {
              console.warn('Shoplift BOCC-65 assignment failed:', error);
              resolve(false);
            });
          return;
        }

        if (Date.now() - startedAt >= 3000) {
          resolve(false);
          return;
        }

        window.setTimeout(checkAssignment, 50);
      }

      checkAssignment();
    });

    return shopliftSubscriptionLabelPromise;
  }

  function initShopliftDescriptionFirst(section) {
    var templateSuffix = section.dataset.templateSuffix || '';
    var isTargetTemplate = templateSuffix === '' || templateSuffix === 'pdp-2-0';

    if (section.dataset.modal === 'true' || !isTargetTemplate) {
      return;
    }

    var upsell = section.querySelector('[data-pdp-upsell]');
    var description = section.querySelector('[data-pdp-description]');

    if (!upsell || !description) {
      return;
    }

    section.dataset.bocc31DescriptionFirst = 'false';
    isShopliftDescriptionFirstVariant().then(function(isActive) {
      section.dataset.bocc31DescriptionFirst = isActive ? 'true' : 'false';

      if (isActive && upsell.parentNode) {
        upsell.parentNode.insertBefore(description, upsell);
      }
    });
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function parseNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function clampCardQuantity(value) {
    return Math.min(4, Math.max(1, value));
  }

  function getFirstAvailablePlan(group, variant) {
    if (!group || !variant || !variant.selling_plan_allocations) {
      return null;
    }

    var availableIds = new Set(
      variant.selling_plan_allocations.map(function(allocation) {
        return String(allocation.selling_plan_id);
      })
    );

    return group.selling_plans.find(function(plan) {
      return availableIds.has(String(plan.id));
    }) || null;
  }

  function getSubscriptionGroup(planPicker) {
    if (!planPicker || !planPicker.availableSellingPlanGroups || !planPicker.availableSellingPlanGroups.length) {
      return null;
    }

    return planPicker.availableSellingPlanGroups.find(function(group) {
      return !!getFirstAvailablePlan(group, planPicker.selectedVariant);
    }) || planPicker.availableSellingPlanGroups[0];
  }

  function getSubscriptionPlan(planPicker) {
    if (!planPicker) {
      return null;
    }

    var selectedGroup = getSubscriptionGroup(planPicker);
    if (!selectedGroup) {
      return null;
    }

    if (planPicker.selectedSellingPlan && selectedGroup.selling_plans.some(function(plan) {
      return String(plan.id) === String(planPicker.selectedSellingPlan.id);
    })) {
      return planPicker.selectedSellingPlan;
    }

    return selectedGroup.selected_selling_plan || getFirstAvailablePlan(selectedGroup, planPicker.selectedVariant);
  }

  function getCurrentVariant(form, planPicker) {
    if (planPicker && planPicker.selectedVariant) {
      return planPicker.selectedVariant;
    }

    var currentVariantJson = form && form.querySelector('[data-current-variant-json]');
    if (currentVariantJson) {
      try {
        return JSON.parse(currentVariantJson.textContent);
      } catch (error) {
        return null;
      }
    }

    var variantJson = form && form.querySelector('[data-variant-json]');
    var variantId = form && form.querySelector('[name="id"]');

    if (variantJson && variantId) {
      try {
        var variants = JSON.parse(variantJson.textContent);
        return variants.find(function(variant) {
          return String(variant.id) === String(variantId.value);
        }) || variants[0] || null;
      } catch (error) {
        return null;
      }
    }

    return null;
  }

  function initProductSection(root) {
    if (!root || root.dataset.initialized === 'true') {
      return;
    }

    root.dataset.initialized = 'true';

    root.querySelectorAll('.product-2-0__tooltip-trigger').forEach(function(trigger) {
      var bubble = trigger.querySelector('[role="tooltip"]');
      if (!bubble) return;
      function positionTooltip() {
        trigger.style.setProperty('--tooltip-shift', '0px');
        var rect = bubble.getBoundingClientRect();
        var width = document.documentElement.clientWidth;
        var shift = Math.max(0, -rect.left) - Math.max(0, rect.right - width);
        trigger.style.setProperty('--tooltip-shift', shift + 'px');
      }
      function showTooltip() {
        trigger.removeAttribute('data-tooltip-dismissed');
        positionTooltip();
      }
      trigger.addEventListener('focus', showTooltip);
      trigger.addEventListener('mouseenter', showTooltip);
      trigger.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
          trigger.setAttribute('data-tooltip-dismissed', '');
          event.stopPropagation();
        }
      });
      window.addEventListener('resize', positionTooltip);
    });

    var section = root.closest('.product-2-0');
    if (!section) {
      return;
    }

    var form = section.querySelector('.product-single__form');
    if (!form) {
      return;
    }

    initShopliftDescriptionFirst(section);

    var quantityInput = section.querySelector('input[name="quantity"][form="' + form.id + '"]') || form.querySelector('input[name="quantity"]');
    var quantityStepper = form.querySelector('.product__quantity');
    var quantityCards = Array.prototype.slice.call(root.querySelectorAll('[data-quantity-card]'));
    var addToCartText = form.querySelector('[data-add-to-cart-text]');
    var addToCartButton = form.querySelector('[data-add-to-cart]');
    var planPicker = section.querySelector('[data-product-2-0-skio] [key]');
    var subscriptionToggle = root.querySelector('[data-plan-toggle="subscription"]');
    var onetimeToggle = root.querySelector('[data-plan-toggle="onetime"]');
    var subscriptionCard = root.querySelector('[data-plan-card="subscription"]');
    var availabilityStatus = section.querySelector('[data-product-availability-status]');
    var quantityOverflowNote = root.querySelector('[data-quantity-overflow-note]');
    var ctaHelper = root.querySelector('[data-cta-helper]');
    var frequencyRow = section.querySelector('.product-subscription__option-row');
    var frequencyPicker = root.querySelector('.product-2-0__frequency-picker');
    var frequencySelect = root.querySelector('[data-frequency-select]');
    var stickyAtc = section.querySelector('[data-sticky-atc]');
    var stickyAtcButton = section.querySelector('[data-sticky-atc-button]');
    var stickyAtcText = section.querySelector('[data-sticky-atc-text]');
    var stickyAtcCompare = section.querySelector('[data-sticky-atc-compare]');
    var stickyAtcPrice = section.querySelector('[data-sticky-atc-price]');
    var stickyCtaHelper = section.querySelector('[data-sticky-cta-helper]');
    var mainPhotos = section.querySelector('.product__main-photos');
    var purchaseExperience = root.dataset.purchaseExperience || 'coffee';
    var isGeneralExperience = purchaseExperience === 'general';
    var supportsSellingPlanOption = root.dataset.subscriptionAvailable === 'true';
    var useQuantityCards = (root.dataset.quantitySelectorStyle || 'buttons') !== 'stepper';

    function clampQuantity(value) {
      var normalized = Math.max(1, parseNumber(value, 1));
      return useQuantityCards ? clampCardQuantity(normalized) : normalized;
    }

    var defaultQuantity = clampQuantity(parseNumber(root.dataset.defaultQuantity, useQuantityCards ? 2 : 1));
    var recommendedQuantity = defaultQuantity === 1 ? 0 : clampCardQuantity(parseNumber(root.dataset.recommendedQuantity, 2));
    var unitLabelSingular = root.dataset.unitLabelSingular || (isGeneralExperience ? 'Item' : 'Bag');
    var unitLabelPlural = root.dataset.unitLabelPlural || (unitLabelSingular + 's');
    var showQuantityMeta = root.dataset.showQuantityMeta
      ? root.dataset.showQuantityMeta !== 'false'
      : !isGeneralExperience;
    var quantityMetaUnitSingular = root.dataset.quantityMetaUnitSingular || 'Cup';
    var quantityMetaUnitPlural = root.dataset.quantityMetaUnitPlural || (quantityMetaUnitSingular + 's');
    var priceSuffix = root.dataset.priceSuffix !== undefined
      ? root.dataset.priceSuffix
      : (isGeneralExperience ? '' : '/ bag');
    var quantity = defaultQuantity;
    var currentVariant = getCurrentVariant(form, planPicker);
    var subscriptionModePreferred = true;
    var galleryTapState = null;
    var lastGalleryZoomAt = 0;

    root.dataset.bocc5SavingsBreakdown = 'false';
    root.dataset.bocc65SubscriptionLabel = 'false';

    function writeText(selector, value) {
      root.querySelectorAll(selector).forEach(function(node) {
        node.textContent = value;
      });
    }

    function toTitleCase(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/\b\w/g, function(character) {
          return character.toUpperCase();
        });
    }

    function normalizeLabel(value, fallback) {
      var normalized = String(value || fallback || '').trim();

      if (!normalized) {
        return fallback || '';
      }

      if (normalized === normalized.toUpperCase()) {
        return toTitleCase(normalized);
      }

      return normalized;
    }

    function normalizeOptionLabel(value) {
      var normalized = String(value || '').trim();

      return normalized === 'Default Title' ? '' : normalized;
    }

    function getSelectedOptionLabel() {
      if (currentVariant && Array.isArray(currentVariant.options) && currentVariant.options.length) {
        if (isGeneralExperience) {
          return currentVariant.options
            .map(normalizeOptionLabel)
            .filter(Boolean)
            .join(' / ');
        }

        return normalizeOptionLabel(currentVariant.options[0]);
      }

      var checkedInput = section.querySelector('[data-variant-input]:checked');
      if (checkedInput && checkedInput.value) {
        return normalizeOptionLabel(checkedInput.value);
      }

      var variantSelect = section.querySelector('select[data-variant-input]');
      if (variantSelect && variantSelect.value) {
        return normalizeOptionLabel(variantSelect.value);
      }

      return '';
    }

    function getActivePurchaseLabel() {
      var titleNode = root.querySelector(
        isSubscriptionSelected()
          ? '[data-plan-toggle="subscription"] .product-2-0__plan-title:not([hidden])'
          : '[data-plan-toggle="onetime"] .product-2-0__plan-title:not([hidden])'
      );

      if (!titleNode) {
        return isSubscriptionSelected()
          ? (isGeneralExperience ? 'Subscribe & Save' : 'Coffee Club')
          : 'One-Time Purchase';
      }

      var normalized = titleNode.textContent
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/^(join|start)\s+/i, '');

      return toTitleCase(normalized);
    }

    function syncQuantityMeta() {
      root.querySelectorAll('[data-quantity-cups]').forEach(function(node) {
        if (!showQuantityMeta) {
          node.textContent = '';
          node.hidden = true;
          return;
        }

        var cupsPerUnit = parseNumber(node.dataset.cupsPerBag, 0);
        if (cupsPerUnit < 1) {
          node.textContent = '';
          node.hidden = true;
          return;
        }

        var displayedCups = cupsPerUnit * quantity;
        var quantityMetaLabel = displayedCups === 1 ? quantityMetaUnitSingular : quantityMetaUnitPlural;

        node.hidden = false;
        node.textContent = '~' + displayedCups + ' ' + quantityMetaLabel + ' total';
      });
    }

    function syncSelectionSummary() {
      var summaryNode = root.querySelector('[data-selection-summary]');
      if (!summaryNode) {
        return;
      }

      var optionLabel = getSelectedOptionLabel();
      var quantityLabel = quantity + ' ' + (quantity === 1 ? unitLabelSingular : unitLabelPlural);
      var purchaseLabel = getActivePurchaseLabel();
      var summary = [optionLabel, quantityLabel, purchaseLabel]
        .filter(Boolean)
        .join(' - ');

      summaryNode.textContent = summary;
      summaryNode.hidden = !summary;
    }

    function setHtml(node, html, fallbackText) {
      if (!node) {
        return;
      }

      node.innerHTML = html;

      if (typeof fallbackText === 'string') {
        node.dataset.defaultText = fallbackText;
      }
    }

    function syncButtonPricing(label, totalPrice) {
      if (!addToCartText) {
        return;
      }

      var fallbackText = totalPrice ? label + ' - ' + totalPrice : label;
      var html = '<span class="product-2-0__button-label">' + label + '</span>';

      if (totalPrice) {
        html += '<span class="product-2-0__button-price">' + totalPrice + '</span>';
      }

      setHtml(addToCartText, html, fallbackText);
    }

    function subscriptionAvailable() {
      return !!(planPicker && getSubscriptionGroup(planPicker) && getSubscriptionPlan(planPicker));
    }

    function currentVariantAvailable() {
      return !!(currentVariant && currentVariant.available);
    }

    function onetimeAllowed() {
      return !(planPicker && planPicker.product && planPicker.product.requires_selling_plan === true);
    }

    function isSubscriptionSelected() {
      if (planPicker && planPicker.product && planPicker.product.requires_selling_plan) {
        return true;
      }

      return !!(planPicker && planPicker.selectedSellingPlanGroup);
    }

    function ensureSellingPlanSelection(forceSubscription) {
      if (!planPicker || !currentVariant) {
        return;
      }

      var group = getSubscriptionGroup(planPicker);
      if (!group) {
        return;
      }

      var availablePlan = getFirstAvailablePlan(group, currentVariant);
      if (!availablePlan) {
        return;
      }

      group.selected_selling_plan = availablePlan;

      if (forceSubscription) {
        planPicker.selectSellingPlan(availablePlan.id);
      }
    }

    function getOneTimeUnitPrice() {
      return currentVariant && currentVariant.price ? currentVariant.price : 0;
    }

    function getSubscriptionUnitPrice() {
      if (!planPicker || !subscriptionAvailable()) {
        return getOneTimeUnitPrice();
      }

      var plan = getSubscriptionPlan(planPicker);
      if (!plan || typeof planPicker.price !== 'function') {
        return getOneTimeUnitPrice();
      }

      return planPicker.price(plan, false);
    }

    function getActiveUnitPrice() {
      return isSubscriptionSelected() ? getSubscriptionUnitPrice() : getOneTimeUnitPrice();
    }

    function getCompareUnitPrice(subscriptionUnitPrice) {
      var oneTimePrice = getOneTimeUnitPrice();
      var comparePrice = currentVariant && currentVariant.compare_at_price ? currentVariant.compare_at_price : 0;
      var baseline = Math.max(comparePrice, oneTimePrice);

      return baseline > subscriptionUnitPrice ? baseline : 0;
    }

    function formatFrequencyLabel() {
      var plan = planPicker ? (planPicker.selectedSellingPlan || getSubscriptionPlan(planPicker)) : null;
      return 'Delivery: ' + formatPlanInterval(plan);
    }

    function parsePlanInterval(plan) {
      if (!plan || !plan.name) {
        return {
          count: 30,
          unit: 'Days',
          days: 30
        };
      }

      var match = String(plan.name).match(/(\d+)\s*(day|days|week|weeks|month|months|year|years)/i);
      var count = match ? parseNumber(match[1], 30) : 30;
      var rawUnit = match ? match[2].toLowerCase() : 'days';
      var unitRoot = rawUnit.replace(/s$/, '');
      var unit = count === 1 ? unitRoot : unitRoot + 's';
      var days = count;

      if (rawUnit.indexOf('week') === 0) {
        days = count * 7;
      } else if (rawUnit.indexOf('month') === 0) {
        days = count * 30;
      } else if (rawUnit.indexOf('year') === 0) {
        days = count * 365;
      }

      return {
        count: count,
        unit: toTitleCase(unit),
        days: days
      };
    }

    function formatPlanInterval(plan) {
      var interval = parsePlanInterval(plan);
      return 'Every ' + interval.count + ' ' + interval.unit;
    }

    function formatFrequencyOptionLabel(plan) {
      return formatPlanInterval(plan);
    }

    function getAvailableFrequencyPlans() {
      if (!planPicker || !currentVariant) {
        return [];
      }

      var group = getSubscriptionGroup(planPicker);
      if (!group) {
        return [];
      }

      if (typeof planPicker.getAvailableSellingPlans === 'function') {
        return planPicker.getAvailableSellingPlans(group) || [];
      }

      return group.selling_plans.filter(function(plan) {
        return currentVariant.selling_plan_allocations.some(function(allocation) {
          return String(allocation.selling_plan_id) === String(plan.id);
        });
      });
    }

    function syncFrequencySelect() {
      if (!frequencySelect) {
        return;
      }

      var plans = getAvailableFrequencyPlans();
      var selectedPlan = planPicker ? (planPicker.selectedSellingPlan || getSubscriptionPlan(planPicker)) : null;
      var selectedValue = selectedPlan ? String(selectedPlan.id) : '';

      frequencySelect.innerHTML = '';

      if (!plans.length) {
        if (frequencyPicker) {
          frequencyPicker.classList.add('is-static');
        }
        var fallbackOption = document.createElement('option');
        fallbackOption.value = '';
        fallbackOption.textContent = 'Every 30 Days';
        frequencySelect.appendChild(fallbackOption);
        frequencySelect.disabled = true;
        return;
      }

      plans.forEach(function(plan) {
        var option = document.createElement('option');
        option.value = String(plan.id);
        option.textContent = formatFrequencyOptionLabel(plan);
        option.selected = selectedValue && String(plan.id) === selectedValue;
        frequencySelect.appendChild(option);
      });

      if (!selectedValue && plans[0]) {
        frequencySelect.value = String(plans[0].id);
      }

      var shouldBeStatic = plans.length <= 1;
      frequencySelect.disabled = shouldBeStatic;

      if (frequencyPicker) {
        frequencyPicker.classList.toggle('is-static', shouldBeStatic);
      }
    }

    function updateFrequencyOptions() {
      if (!frequencyRow || !currentVariant || !currentVariant.selling_plan_allocations) {
        syncFrequencySelect();
        return;
      }

      var availableIds = new Set(
        currentVariant.selling_plan_allocations.map(function(allocation) {
          return String(allocation.selling_plan_id);
        })
      );

      var visibleCount = 0;
      Array.prototype.slice.call(section.querySelectorAll('.freq-button')).forEach(function(button) {
        var visible = availableIds.has(String(button.dataset.spId));
        button.hidden = !visible;
        if (visible) {
          visibleCount += 1;
        }
      });

      Array.prototype.slice.call(section.querySelectorAll('.product-subscription__option-list')).forEach(function(list) {
        var hasVisibleButtons = Array.prototype.slice.call(list.querySelectorAll('.freq-button')).some(function(button) {
          return !button.hidden;
        });

        list.hidden = !hasVisibleButtons;
      });

      syncFrequencySelect();
    }

    function syncButtonLabel() {
      if (!addToCartText) {
        return;
      }

      var desiredLabel = isSubscriptionSelected()
        ? root.dataset.subscriptionCtaLabel
        : root.dataset.onetimeCtaLabel;

      desiredLabel = normalizeLabel(
        desiredLabel,
        isSubscriptionSelected() ? 'Add to Cart' : 'Add to Cart'
      );

      var totalPrice = supportsSellingPlanOption && currentVariant
        ? formatMoney(getActiveUnitPrice() * quantity)
        : '';

      if (!addToCartButton || !addToCartButton.disabled) {
        syncButtonPricing(desiredLabel, totalPrice);
      }
    }

    function syncQuantityCards() {
      var activeModePrice = getActiveUnitPrice();

      if (quantityStepper) {
        quantityStepper.classList.toggle('is-recommended', quantity === recommendedQuantity);
      }

      quantityCards.forEach(function(card) {
        var cardQty = clampCardQuantity(parseNumber(card.dataset.quantityCard, 1));
        card.classList.toggle('is-selected', cardQty === quantity);
        card.setAttribute('aria-pressed', cardQty === quantity ? 'true' : 'false');
        writeText('[data-quantity-total="' + cardQty + '"]', formatMoney(activeModePrice * cardQty));
      });
    }

    function syncQuantityOverflowNote() {
      if (!quantityOverflowNote) {
        return;
      }

      quantityOverflowNote.hidden = quantity !== 4;
    }

    function syncSubscriptionSavingsLayout(savingsPercent, orderSavings, totalOrderSavings) {
      var showBreakdown = root.dataset.bocc5SavingsBreakdown === 'true';
      var defaultCopy = root.querySelectorAll(
        '[data-onetime-copy-default], [data-subscription-headline-default], ' +
        '[data-subscription-benefits-default], [data-subscription-price-default]'
      );
      var breakdownCopy = root.querySelectorAll(
        '[data-onetime-title-breakdown], [data-onetime-price-breakdown], ' +
        '[data-subscription-headline-breakdown], [data-subscription-benefits-breakdown], ' +
        '[data-subscription-price-breakdown]'
      );

      defaultCopy.forEach(function(node) {
        node.hidden = showBreakdown;
      });
      breakdownCopy.forEach(function(node) {
        node.hidden = !showBreakdown;
      });

      if (!showBreakdown) {
        return;
      }

      writeText('[data-subscription-discount-percent]', savingsPercent + '%');
      var productSavingsRow = root.querySelector('[data-subscription-product-savings-row]');
      var savingsQuantityLabel = quantity + ' ' + (quantity === 1 ? unitLabelSingular : unitLabelPlural);

      if (productSavingsRow) {
        productSavingsRow.hidden = orderSavings <= 0;
      }

      writeText('[data-subscription-product-savings-label]', savingsQuantityLabel + ' savings');
      writeText('[data-subscription-product-savings-total]', formatMoney(orderSavings));
      writeText('[data-subscription-shipping-price]', formatMoney(SUBSCRIPTION_SHIPPING_SAVINGS_CENTS));
      writeText('[data-subscription-total-savings]', formatMoney(totalOrderSavings));
    }

    function isMobileGalleryZoomViewport() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    function getTouchPoint(event) {
      if (event.changedTouches && event.changedTouches.length) {
        return event.changedTouches[0];
      }

      if (event.touches && event.touches.length) {
        return event.touches[0];
      }

      return null;
    }

    function initMobileGalleryZoom() {
      if (!mainPhotos) {
        return;
      }

      function openSelectedGalleryZoom() {
        var zoomTrigger = getSelectedZoomTrigger();

        if (!zoomTrigger) {
          return;
        }

        lastGalleryZoomAt = Date.now();
        zoomTrigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      }

      function getSelectedZoomTrigger() {
        return mainPhotos.querySelector('.product-main-slide.is-selected .js-photoswipe__zoom');
      }

      function isInteractiveTarget(target) {
        return !!target.closest('.flickity-prev-next-button, .product__photo-zoom, a, button, video, iframe, model-viewer');
      }

      function isSelectedImageTapTarget(target) {
        var selectedSlide = target.closest('.product-main-slide.is-selected');
        if (!selectedSlide) {
          return false;
        }

        var imageWrap = target.closest('.image-wrap');
        var image = selectedSlide.querySelector('.photoswipe__image');
        return !!(imageWrap && image && imageWrap.contains(image));
      }

      mainPhotos.addEventListener('touchstart', function(event) {
        if (!isMobileGalleryZoomViewport() || isInteractiveTarget(event.target)) {
          galleryTapState = null;
          return;
        }

        if (!isSelectedImageTapTarget(event.target)) {
          galleryTapState = null;
          return;
        }

        var touch = getTouchPoint(event);
        if (!touch || !getSelectedZoomTrigger()) {
          galleryTapState = null;
          return;
        }

        galleryTapState = {
          identifier: touch.identifier,
          startX: touch.clientX,
          startY: touch.clientY
        };
      }, { passive: true });

      mainPhotos.addEventListener('touchend', function(event) {
        if (!galleryTapState || !isMobileGalleryZoomViewport() || isInteractiveTarget(event.target)) {
          galleryTapState = null;
          return;
        }

        var touch = getTouchPoint(event);
        var zoomTrigger = getSelectedZoomTrigger();

        if (!touch || !zoomTrigger) {
          galleryTapState = null;
          return;
        }

        if (typeof galleryTapState.identifier === 'number' && typeof touch.identifier === 'number' && galleryTapState.identifier !== touch.identifier) {
          galleryTapState = null;
          return;
        }

        var deltaX = Math.abs(touch.clientX - galleryTapState.startX);
        var deltaY = Math.abs(touch.clientY - galleryTapState.startY);

        galleryTapState = null;

        if (deltaX > 10 || deltaY > 10) {
          return;
        }

        openSelectedGalleryZoom();
      }, { passive: true });

      mainPhotos.addEventListener('touchcancel', function() {
        galleryTapState = null;
      }, { passive: true });

      mainPhotos.addEventListener('click', function(event) {
        if (!isMobileGalleryZoomViewport() || isInteractiveTarget(event.target) || !isSelectedImageTapTarget(event.target)) {
          return;
        }

        if (Date.now() - lastGalleryZoomAt < 500) {
          return;
        }

        event.preventDefault();
        openSelectedGalleryZoom();
      });
    }

    function syncStickyAtc() {
      if (!stickyAtc || !stickyAtcButton || !stickyAtcText) {
        return;
      }

      var variantAvailable = currentVariantAvailable();
      stickyAtc.hidden = !variantAvailable;

      if (!variantAvailable) {
        stickyAtc.classList.remove('is-visible');
        return;
      }

      if (addToCartText) {
        var liveLabel = addToCartText.querySelector('.product-2-0__button-label');
        var liveCompare = addToCartText.querySelector('.product-2-0__button-compare');
        var livePrice = addToCartText.querySelector('.product-2-0__button-price');

        stickyAtcText.textContent = liveLabel ? liveLabel.textContent : addToCartText.textContent;

        if (stickyAtcCompare) {
          stickyAtcCompare.textContent = liveCompare ? liveCompare.textContent : '';
          stickyAtcCompare.hidden = !liveCompare || !liveCompare.textContent;
        }

        if (stickyAtcPrice) {
          var stickyPriceText = livePrice ? livePrice.textContent : '';
          stickyAtcPrice.textContent = stickyPriceText;
          stickyAtcPrice.hidden = !stickyPriceText;
        }
      }

      stickyAtcButton.disabled = !!(addToCartButton && addToCartButton.disabled);
      stickyAtcButton.classList.toggle('is-disabled', stickyAtcButton.disabled);
    }

    function setStickyAtcVisibility(visible) {
      if (!stickyAtc) {
        return;
      }

      stickyAtc.classList.toggle('is-visible', visible && currentVariantAvailable());
    }

    function initStickyAtcObserver() {
      if (!stickyAtc || !addToCartButton) {
        return;
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function(entries) {
            entries.forEach(function(entry) {
              setStickyAtcVisibility(!entry.isIntersecting);
            });
          },
          {
            threshold: 0.2
          }
        );

        observer.observe(addToCartButton);
        return;
      }

      function onScroll() {
        var rect = addToCartButton.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var visible = rect.top < viewportHeight && rect.bottom > 0;
        setStickyAtcVisibility(!visible);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    var uiUpdateQueued = false;
    function updateUi() {
      if (uiUpdateQueued) return;
      uiUpdateQueued = true;
      queueMicrotask(function() {
        uiUpdateQueued = false;
        if (root.isConnected) renderUi();
      });
    }

    function renderUi() {
      currentVariant = getCurrentVariant(form, planPicker) || currentVariant;

      var variantAvailable = currentVariantAvailable();
      var subscriptionExists = subscriptionAvailable();

      if (!subscriptionExists) {
        subscriptionModePreferred = false;

        if (
          planPicker &&
          typeof planPicker.selectSellingPlanGroup === 'function' &&
          planPicker.selectedSellingPlanGroup &&
          !(planPicker.product && planPicker.product.requires_selling_plan)
        ) {
          planPicker.selectSellingPlanGroup(null);
        }
      }

      var subscriptionActive = variantAvailable && subscriptionExists && isSubscriptionSelected();
      var subscriptionUnitPrice = getSubscriptionUnitPrice();
      var oneTimeUnitPrice = getOneTimeUnitPrice();
      var savingsPerUnit = Math.max(oneTimeUnitPrice - subscriptionUnitPrice, 0);
      var orderSavings = Math.max(savingsPerUnit * quantity, 0);
      var totalOrderSavings = subscriptionExists ? orderSavings + SUBSCRIPTION_SHIPPING_SAVINGS_CENTS : 0;
      var selectedPlan = planPicker ? (planPicker.selectedSellingPlan || getSubscriptionPlan(planPicker)) : null;
      var optionLabel = getSelectedOptionLabel();
      var quantityLabel = quantity + ' ' + (quantity === 1 ? unitLabelSingular : unitLabelPlural).toLowerCase();
      var helperParts = optionLabel ? [optionLabel, quantityLabel] : [quantityLabel];
      helperParts.push(
        subscriptionActive
          ? formatMoney(subscriptionUnitPrice) + priceSuffix
          : formatMoney(oneTimeUnitPrice) + priceSuffix
      );
      helperParts.push(subscriptionActive ? 'Cancel anytime' : 'Shipping calculated at checkout');
      var helperText = variantAvailable && subscriptionExists ? helperParts.join(' · ') : '';

      root.dataset.purchaseMode = subscriptionActive ? 'subscription' : 'onetime';
      root.dataset.subscriptionAvailable = subscriptionExists ? 'true' : 'false';
      root.dataset.variantAvailable = variantAvailable ? 'true' : 'false';
      section.dataset.variantAvailable = variantAvailable ? 'true' : 'false';

      if (availabilityStatus) {
        availabilityStatus.textContent = root.dataset.soldOutLabel || 'Sold out';
        availabilityStatus.hidden = variantAvailable;
      }

      if (subscriptionToggle) {
        subscriptionToggle.classList.toggle('is-selected', subscriptionActive);
        subscriptionToggle.setAttribute('aria-pressed', subscriptionActive ? 'true' : 'false');
      }

      if (subscriptionCard) {
        subscriptionCard.classList.toggle('is-selected', subscriptionActive);
        subscriptionCard.classList.toggle('is-unavailable', !subscriptionExists);
      }

      if (onetimeToggle) {
        onetimeToggle.classList.toggle('is-selected', !subscriptionActive);
        onetimeToggle.setAttribute('aria-pressed', subscriptionActive ? 'false' : 'true');
        onetimeToggle.disabled = !onetimeAllowed();
      }

      if (ctaHelper) {
        ctaHelper.textContent = helperText;
        ctaHelper.hidden = !helperText;
      }

      if (stickyCtaHelper) {
        stickyCtaHelper.textContent = helperText;
        stickyCtaHelper.hidden = !helperText;
      }

      writeText('[data-frequency-label]', formatFrequencyLabel());
      writeText('[data-subscription-unit-price]', formatMoney(subscriptionUnitPrice));
      writeText('[data-onetime-unit-price]', formatMoney(oneTimeUnitPrice));
      var savingsPercent = oneTimeUnitPrice > 0 ? Math.round((savingsPerUnit / oneTimeUnitPrice) * 100) : 0;
      root.querySelectorAll('[data-subscription-save-badge]').forEach(function(node) {
        var showBadge = savingsPercent > 0;
        node.hidden = !showBadge;
        if (showBadge) {
          node.textContent = 'Save ' + savingsPercent + '%';
        }
      });
      writeText(
        '[data-subscription-headline-savings]',
        root.dataset.bocc65SubscriptionLabel === 'true'
          ? 'On'
          : (totalOrderSavings ? formatMoney(totalOrderSavings) + '+' : '$11.85+')
      );
      syncSubscriptionSavingsLayout(savingsPercent, orderSavings, totalOrderSavings);
      root.querySelectorAll('[data-onetime-inline-price]').forEach(function(node) {
        node.textContent = formatMoney(oneTimeUnitPrice);
      });

      syncQuantityMeta();
      syncSelectionSummary();
      syncQuantityCards();
      syncQuantityOverflowNote();
      syncButtonLabel();
      syncStickyAtc();
      updateFrequencyOptions();
    }

    function setQuantity(nextQuantity) {
      quantity = clampQuantity(nextQuantity);

      if (quantityInput) {
        quantityInput.value = quantity;
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      updateUi();
    }

    function setPurchaseMode(mode) {
      subscriptionModePreferred = mode === 'subscription';

      if (!planPicker) {
        updateUi();
        return;
      }

      if (mode === 'subscription') {
        ensureSellingPlanSelection(true);
      } else if (onetimeAllowed()) {
        planPicker.selectSellingPlanGroup(null);
      }

      updateUi();
    }

    quantityCards.forEach(function(card) {
      card.addEventListener('click', function() {
        setQuantity(parseNumber(card.dataset.quantityCard, quantity));
      });
    });

    if (stickyAtcButton) {
      stickyAtcButton.addEventListener('click', function() {
        if (!addToCartButton || addToCartButton.disabled) {
          return;
        }

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(addToCartButton);
        } else {
          addToCartButton.click();
        }
      });
    }

    if (frequencySelect) {
      frequencySelect.addEventListener('change', function() {
        if (!planPicker || !this.value) {
          return;
        }

        ensureSellingPlanSelection(false);
        planPicker.selectSellingPlan(this.value);
        subscriptionModePreferred = true;
        updateUi();
      });
    }

    if (subscriptionToggle) {
      subscriptionToggle.addEventListener('click', function() {
        if (subscriptionAvailable()) {
          setPurchaseMode('subscription');
        }
      });
    }

    if (onetimeToggle) {
      onetimeToggle.addEventListener('click', function() {
        if (onetimeAllowed()) {
          setPurchaseMode('onetime');
        }
      });
    }

    section.addEventListener('variantChange', function(event) {
      currentVariant = event.detail && event.detail.variant ? event.detail.variant : currentVariant;

      window.setTimeout(function() {
        if (subscriptionModePreferred && subscriptionAvailable()) {
          ensureSellingPlanSelection(true);
        } else {
          ensureSellingPlanSelection(false);
        }

        updateUi();
      }, 0);
    });

    if (planPicker) {
      section.addEventListener('skio::update-selling-plan', function() {
        currentVariant = getCurrentVariant(form, planPicker) || currentVariant;
        updateUi();
      });
    }

    form.addEventListener('change', function(event) {
      if (event.target && event.target.name === 'quantity') {
        quantity = clampQuantity(parseNumber(event.target.value, quantity));
        updateUi();
      }
    });

    if (quantityInput) {
      var syncQuantityFromInput = function() {
        quantity = clampQuantity(parseNumber(this.value, quantity));
        updateUi();
      };

      quantityInput.addEventListener('input', syncQuantityFromInput);
      quantityInput.addEventListener('change', syncQuantityFromInput);
    }

    root.querySelectorAll('.freq-button').forEach(function(button) {
      button.addEventListener('click', function() {
        window.setTimeout(updateUi, 0);
      });
    });

    if (planPicker) {
      customElements.whenDefined(planPicker.localName).then(function() {
        window.setTimeout(function() {
          currentVariant = getCurrentVariant(form, planPicker) || currentVariant;
          ensureSellingPlanSelection(true);
          updateUi();
          setQuantity(quantity || defaultQuantity);
          if (subscriptionAvailable()) {
            setPurchaseMode('subscription');
          }
        }, 0);
      });
    } else {
      setQuantity(quantity || defaultQuantity);
      updateUi();
    }

    if (planPicker) {
      isShopliftSavingsBreakdownVariant().then(function(isActive) {
        root.dataset.bocc5SavingsBreakdown = isActive ? 'true' : 'false';
        updateUi();
      });

      isShopliftSubscriptionLabelVariant().then(function(isActive) {
        root.dataset.bocc65SubscriptionLabel = isActive ? 'true' : 'false';
        updateUi();
      });
    }

    quantityCards.forEach(function(card) {
      card.classList.toggle('is-recommended', parseNumber(card.dataset.quantityCard, 0) === recommendedQuantity);
    });

    initMobileGalleryZoom();
    initStickyAtcObserver();
  }

  function createPdpUpsellRecommendationCard(product, upsell) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var availableVariants = variants.filter(function(variant) {
      return variant.available;
    });
    var selectedVariant = availableVariants[0];

    if (!selectedVariant) {
      return null;
    }

    var card = document.createElement('article');
    card.className = 'product-2-0__upsell-card';
    card.dataset.pdpUpsellCard = '';
    card.dataset.upsellProductId = String(product.id);
    card.dataset.upsellProductHandle = product.handle || '';

    var selection = document.createElement('div');
    selection.className = 'product-2-0__upsell-selection';

    var checkboxId = 'PdpUpsellRecommendationSelect-' + product.id;
    var checkbox = document.createElement('input');
    checkbox.id = checkboxId;
    checkbox.className = 'product-2-0__upsell-checkbox';
    checkbox.type = 'checkbox';
    checkbox.checked = true;
    checkbox.dataset.pdpUpsellSelect = '';
    selection.appendChild(checkbox);
    card.appendChild(selection);

    var imageToggle = document.createElement('label');
    imageToggle.className = 'product-2-0__upsell-image-toggle';
    imageToggle.htmlFor = checkboxId;

    if (product.featured_image) {
      var image = document.createElement('img');
      image.className = 'product-2-0__upsell-image';
      image.src = product.featured_image;
      image.width = 144;
      image.height = 144;
      image.loading = 'lazy';
      image.alt = '';
      imageToggle.appendChild(image);
    }

    var imageToggleText = document.createElement('span');
    imageToggleText.className = 'visually-hidden';
    imageToggleText.textContent = 'Select ' + product.title;
    imageToggle.appendChild(imageToggleText);
    card.appendChild(imageToggle);

    var details = document.createElement('div');
    details.className = 'product-2-0__upsell-details';

    var title = document.createElement('a');
    title.className = 'product-2-0__upsell-title';
    title.href = product.url || ('/products/' + product.handle);
    title.textContent = product.title;
    details.appendChild(title);

    var priceRow = document.createElement('div');
    priceRow.className = 'product-2-0__upsell-price-row';
    priceRow.setAttribute('aria-live', 'polite');

    var price = document.createElement('span');
    price.dataset.pdpUpsellPrice = '';
    price.textContent = formatMoney(selectedVariant.price);
    priceRow.appendChild(price);

    var comparePrice = document.createElement('s');
    comparePrice.dataset.pdpUpsellComparePrice = '';
    comparePrice.hidden = !(selectedVariant.compare_at_price > selectedVariant.price);
    comparePrice.textContent = comparePrice.hidden ? '' : formatMoney(selectedVariant.compare_at_price);
    priceRow.appendChild(comparePrice);
    details.appendChild(priceRow);

    var variantInput;
    if (availableVariants.length > 1 || selectedVariant.title !== 'Default Title') {
      var variantId = 'PdpUpsellRecommendationVariant-' + product.id;
      var label = document.createElement('label');
      label.className = 'visually-hidden';
      label.htmlFor = variantId;
      label.textContent = 'Choose an option for ' + product.title;
      details.appendChild(label);

      variantInput = document.createElement('select');
      variantInput.id = variantId;
      variantInput.className = 'product-2-0__upsell-variant';
      variantInput.dataset.pdpUpsellVariant = '';

      availableVariants.forEach(function(variant) {
        var option = document.createElement('option');
        option.value = String(variant.id);
        option.dataset.price = formatMoney(variant.price);
        option.dataset.comparePrice = variant.compare_at_price > variant.price
          ? formatMoney(variant.compare_at_price)
          : '';
        option.selected = String(variant.id) === String(selectedVariant.id);
        option.textContent = variant.title;
        variantInput.appendChild(option);
      });
    } else {
      variantInput = document.createElement('input');
      variantInput.type = 'hidden';
      variantInput.value = String(selectedVariant.id);
      variantInput.dataset.pdpUpsellVariant = '';
    }

    details.appendChild(variantInput);
    card.appendChild(details);

    return card;
  }

  function bindPdpUpsell(upsell) {
    var status = upsell.querySelector('[data-pdp-upsell-status]');
    var addSelectedButton = upsell.querySelector('[data-pdp-upsell-add-selected]');

    function setStatus(message) {
      if (status) {
        status.textContent = message || '';
      }
    }

    function getSelectedCards() {
      return Array.prototype.slice.call(upsell.querySelectorAll('[data-pdp-upsell-card]')).filter(function(card) {
        var checkbox = card.querySelector('[data-pdp-upsell-select]');
        return checkbox && checkbox.checked && !checkbox.disabled;
      });
    }

    function syncSelectedState() {
      var selectedCards = getSelectedCards();

      upsell.querySelectorAll('[data-pdp-upsell-card]').forEach(function(card) {
        var checkbox = card.querySelector('[data-pdp-upsell-select]');
        card.classList.toggle('is-unselected', !!checkbox && !checkbox.checked);
      });

      if (addSelectedButton && !addSelectedButton.classList.contains('is-loading')) {
        addSelectedButton.disabled = selectedCards.length === 0;
      }
    }

    upsell.querySelectorAll('[data-pdp-upsell-select]').forEach(function(checkbox) {
      if (checkbox.dataset.upsellBound === 'true') {
        return;
      }

      checkbox.dataset.upsellBound = 'true';
      checkbox.addEventListener('change', function() {
        var buttonText = addSelectedButton && addSelectedButton.querySelector('[data-pdp-upsell-button-text]');
        if (buttonText && !addSelectedButton.classList.contains('is-loading')) {
          buttonText.textContent = addSelectedButton.dataset.defaultLabel || 'Add selected to cart';
        }
        setStatus('');
        syncSelectedState();
      });
    });

    upsell.querySelectorAll('[data-pdp-upsell-variant]').forEach(function(select) {
      if (select.tagName !== 'SELECT' || select.dataset.upsellBound === 'true') {
        return;
      }

      select.dataset.upsellBound = 'true';
      select.addEventListener('change', function() {
        var card = select.closest('[data-pdp-upsell-card]');
        var option = select.options[select.selectedIndex];
        var price = card && card.querySelector('[data-pdp-upsell-price]');
        var comparePrice = card && card.querySelector('[data-pdp-upsell-compare-price]');

        if (price && option) {
          price.textContent = option.dataset.price || '';
        }

        if (comparePrice && option) {
          comparePrice.textContent = option.dataset.comparePrice || '';
          comparePrice.hidden = !option.dataset.comparePrice;
        }
      });
    });

    if (addSelectedButton && addSelectedButton.dataset.upsellBound !== 'true') {
      addSelectedButton.dataset.upsellBound = 'true';
      addSelectedButton.addEventListener('click', async function() {
        var selectedCards = getSelectedCards();
        var selectedItems = selectedCards.map(function(card) {
          var variantInput = card.querySelector('[data-pdp-upsell-variant]');
          return {
            card: card,
            variantId: variantInput && variantInput.value
          };
        }).filter(function(item) {
          return !!item.variantId;
        });
        var buttonText = addSelectedButton.querySelector('[data-pdp-upsell-button-text]');
        var defaultLabel = addSelectedButton.dataset.defaultLabel || 'Add selected to cart';
        var successLabel = addSelectedButton.dataset.successLabel || 'Added to cart';

        if (!selectedItems.length || addSelectedButton.disabled) {
          syncSelectedState();
          return;
        }

        addSelectedButton.disabled = true;
        addSelectedButton.classList.add('is-loading');
        addSelectedButton.setAttribute('aria-busy', 'true');
        if (buttonText) buttonText.textContent = 'Adding selected…';
        setStatus('Adding ' + selectedItems.length + (selectedItems.length === 1 ? ' item' : ' items') + ' to your cart…');

        try {
          var response = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: selectedItems.map(function(item) {
                return { id: Number(item.variantId), quantity: 1 };
              })
            })
          });

          var responseData = await response.json();
          if (!response.ok) {
            throw new Error(responseData.description || responseData.message || 'This item could not be added.');
          }

          selectedItems.forEach(function(item) {
            var checkbox = item.card.querySelector('[data-pdp-upsell-select]');
            item.card.classList.add('is-added');
            if (checkbox) checkbox.disabled = true;
          });

          addSelectedButton.classList.remove('is-loading');
          addSelectedButton.removeAttribute('aria-busy');
          if (buttonText) buttonText.textContent = successLabel;
          setStatus('Added ' + selectedItems.length + (selectedItems.length === 1 ? ' item' : ' items') + ' to your cart.');

          window.dataLayer = window.dataLayer || [];
          selectedItems.forEach(function(item) {
            window.dataLayer.push({
              event: 'pdp_upsell_add',
              source_product_id: upsell.dataset.sourceProductId,
              source_product_handle: upsell.dataset.sourceProductHandle,
              source_collection_handle: upsell.dataset.sourceCollectionHandle,
              upsell_source: upsell.dataset.upsellSource,
              upsell_collection_handle: upsell.dataset.upsellCollectionHandle,
              upsell_product_id: item.card.dataset.upsellProductId,
              upsell_product_handle: item.card.dataset.upsellProductHandle,
              upsell_variant_id: String(item.variantId),
              selected_item_count: selectedItems.length
            });
          });

          selectedItems.forEach(function(item) {
            item.card.remove();
          });

          var hasEligibleCards = Array.prototype.some.call(
            upsell.querySelectorAll('[data-pdp-upsell-card]'),
            function(card) {
              return !card.hidden && !card.classList.contains('is-added');
            }
          );

          if (!hasEligibleCards) {
            upsell.hidden = true;
          } else {
            syncSelectedState();
          }

          if (upsell.dataset.openCart === 'true') {
            window.setTimeout(function() {
              if (typeof window.BoccCartOpen === 'function') {
                window.BoccCartOpen({ trigger: addSelectedButton });
                return;
              }

              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: { product: responseData.items && responseData.items[0] }
              }));
              document.dispatchEvent(new CustomEvent('cart:open'));
            }, 200);
          }
        } catch (error) {
          addSelectedButton.classList.remove('is-loading');
          addSelectedButton.removeAttribute('aria-busy');
          if (buttonText) buttonText.textContent = defaultLabel;
          setStatus(error.message || 'The selected items could not be added. Please try again.');
          syncSelectedState();
        }
      });
    }

    syncSelectedState();

    if ('IntersectionObserver' in window && upsell.dataset.impressionObserved !== 'true') {
      upsell.dataset.impressionObserved = 'true';
      var impressionObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) {
            return;
          }

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'pdp_upsell_view',
            source_product_id: upsell.dataset.sourceProductId,
            source_product_handle: upsell.dataset.sourceProductHandle,
            source_collection_handle: upsell.dataset.sourceCollectionHandle,
            upsell_source: upsell.dataset.upsellSource,
            upsell_collection_handle: upsell.dataset.upsellCollectionHandle
          });
          impressionObserver.disconnect();
        });
      }, { threshold: 0.5 });

      impressionObserver.observe(upsell);
    }
  }

  async function loadPdpUpsellRecommendations(upsell) {
    var list = upsell.querySelector('[data-pdp-upsell-list]');
    var sourceProductId = upsell.dataset.sourceProductId;
    var maxProducts = parseNumber(upsell.dataset.maxProducts, 3);
    var cartProductIds = (upsell.dataset.cartProductIds || '').split(',').filter(Boolean);
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var url = root + 'recommendations/products.json?product_id=' + encodeURIComponent(sourceProductId) + '&limit=10&intent=related';

    if (!list || !sourceProductId) {
      return;
    }

    try {
      var response = await fetch(url, { headers: { 'Accept': 'application/json' } });
      if (!response.ok) {
        throw new Error('Recommendations unavailable.');
      }

      var responseData = await response.json();
      var products = Array.isArray(responseData.products) ? responseData.products : [];
      var renderedProducts = 0;

      products.some(function(recommendedProduct) {
        if (
          renderedProducts >= maxProducts ||
          !recommendedProduct.available ||
          String(recommendedProduct.id) === String(sourceProductId) ||
          cartProductIds.indexOf(String(recommendedProduct.id)) !== -1
        ) {
          return renderedProducts >= maxProducts;
        }

        var card = createPdpUpsellRecommendationCard(recommendedProduct, upsell);
        if (card) {
          list.appendChild(card);
          renderedProducts += 1;
        }

        return renderedProducts >= maxProducts;
      });

      if (!renderedProducts) {
        return;
      }

      list.removeAttribute('aria-busy');
      upsell.hidden = false;
      bindPdpUpsell(upsell);
    } catch (error) {
      list.removeAttribute('aria-busy');
    }
  }

  function initPdpUpsell(upsell) {
    if (!upsell || upsell.dataset.initialized === 'true') {
      return;
    }

    upsell.dataset.initialized = 'true';

    if (upsell.dataset.useShopifyRecommendations === 'true') {
      loadPdpUpsellRecommendations(upsell);
      return;
    }

    bindPdpUpsell(upsell);
  }

  function initAll(context) {
    var scope = context || document;
    scope.querySelectorAll('[data-product-2-0]').forEach(initProductSection);
    scope.querySelectorAll('[data-pdp-upsell]').forEach(initPdpUpsell);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });
})();
